import React from "react";
import { useState } from "react";
import { api } from 'api';

/**
 * Hook para realizar peticiones a la API relacionadas a los contenedores de ingresos.
 * @returns {Object} Objeto con las funciones y estados necesarios para los contenedores de ingresos.
 */
export const ContenedorApi = () => {
    const [cargando, setCargando] = useState(false);

    // FINCAS
    const [fincas, setFincas] = useState([]);

    const getFincas = async (inputValue) => {
        try {
            // setCargando(true);
            const response = await api.get('finca', { search: inputValue || '', de_baja: false });
            if (!response.results) return [];
            const data = response.results;
            const dataForSelect = data.map(finca => ({ value: finca.id, label: finca.nombre }));

            setFincas(dataForSelect)
            return dataForSelect;
        } catch (error) {
            console.error(error);
            setFincas([]);
            return [];
        } finally {
            setCargando(false);
        }
    }

    // TIPOS MATERIA PRIMA
    const [tiposMateriaPrima, setTiposMateriaPrima] = useState([]);

    const getTiposMateriaPrima = async () => {
        try {
            setCargando(true);
            const response = await api.get('tipo_materia_prima', { de_baja: false });
            if (!response.results) return [];
            const data = response.results;
            const dataForSelect = data.map(tipo_materia_prima => (
                {
                    value: tipo_materia_prima.id,
                    label: tipo_materia_prima.nombre,
                    tipo: tipo_materia_prima.tipo
                }));

            setTiposMateriaPrima(dataForSelect)
            return dataForSelect;
        } catch (error) {
            console.error(error);
            setTiposMateriaPrima([]);
            return [];
        } finally {
            setCargando(false);
        }
    }

    // PRODUCTOS LATEX
    const [productosLatex, setProductosLatex] = useState([]);

    const getProductosLatex = async () => {
        try {
            setCargando(true);
            const response = await api.get('materia_prima/?search=Latex&no_paginar=true');
            if (!response.results) return [];
            const data = response.results;
            const dataForSelect = data.map(producto => ({ value: producto.id, label: producto.nombre }));

            setProductosLatex(dataForSelect)
            return dataForSelect;
        } catch (error) {
            console.error(error);
            setProductosLatex([]);
            return [];
        } finally {
            setCargando(false);
        }
    }

    // PRODUCTOS SOLIDOS
    const [productosSolidos, setProductosSolidos] = useState([]);

    const getProductosSolidos = async () => {
        try {
            setCargando(true);
            const response = await api.get('materia_prima/?search=Solido&no_paginar=true');
            if (!response.results) return [];
            const data = response.results;
            const dataForSelect = data.map(producto => ({ value: producto.id, label: producto.nombre }));

            setProductosSolidos(dataForSelect)
            return dataForSelect;
        } catch (error) {
            console.error(error);
            setProductosSolidos([]);
            return [];
        } finally {
            setCargando(false);
        }
    }

    // PESO DE BÁSCULA
    const [pesoBascula, setPesoBascula] = useState(null);
    const getPesoBascula = async () => {
        try {
            setCargando(true);
            const response = await api.getPesosBascula();
            if (!response.text) {
                setPesoBascula(null);
                return null
            };
            setPesoBascula(response.text);
            return response.text;
        } catch (error) {
            console.error(error);
            setPesoBascula(null);
            return null;
        } finally {
            setCargando(false);
        }
    }

    return {
        getFincas,
        fincas,

        getTiposMateriaPrima,
        tiposMateriaPrima,

        getProductosLatex,
        productosLatex,

        getProductosSolidos,
        productosSolidos,

        pesoBascula,
        getPesoBascula,

        cargando
    }
}
